import { Link } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import EnquiryForm from "../components/common/EnquiryForm";

export default function Community() {
  return (
    <main className="pt-16 md:pt-20">
      <section
        className="relative w-full h-64 md:h-80"
        style={{ backgroundImage: "url('/static/images/hero-community.webp')", backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/50" />
      </section>

      <section className="w-full bg-white">
        <div className="flex flex-col md:flex-row min-h-[500px]">
          <div className="w-full md:w-1/2 flex items-center px-8 md:px-16 lg:px-24 py-12">
            <div className="max-w-sm">
              <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-5">The Artistic Spaces Community</h1>
              <p className="text-gray-600 leading-relaxed text-base">
                At Artistic Spaces, we believe that creativity thrives in community. Our spaces are home to a diverse network of creators, makers, and visionaries working together to inspire, collaborate, and achieve their goals. Join us and be part of a community that supports your creative journey every step of the way.
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 min-h-[320px] md:min-h-[500px] overflow-hidden">
            <img src="/static/images/howitworks-intro-pic.webp" alt="Artistic Spaces Community" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="w-full bg-white px-8 md:px-16 lg:px-24 py-16">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4">Update</h2>
        <p className="text-gray-600 leading-relaxed text-base max-w-2xl mb-12">
          Stay up-to-date with the latest news and announcements from Artistic Spaces. From upcoming events and new studio openings to member spotlights and exciting collaborations, this is your go-to source for all things happening in our vibrant community.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="group flex flex-col">
              <div className="aspect-[4/3] bg-gray-100 overflow-hidden mb-4">
                <img
                  src={post.heroImageUrl}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { e.target.src = "/static/images/hero-community.webp"; }}
                />
              </div>
              <h3 className="text-base font-semibold text-gray-900 group-hover:text-teal-700 transition-colors duration-200">
                {post.title}
              </h3>
            </Link>
          ))}
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/community" pageName="Community" />
    </main>
  );
}